import { Box, Tab, Tabs } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import BarChart from "@mui/icons-material/BarChart";
import { useState } from "react";
import GraduateReportStatusPage from "./GraduateReportStatus";
import { MasteryLevelPage } from "../PillarMasteryLevel.tsx/MasteryLevelPage";

export const Portfolio = () => {
  const [currentTab, setCurrentTab] = useState("graduation");

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        position:'relative'
      }}
    >
      <Tabs
        sx={{
          background: "#0a0c18",
          position: "sticky",
          top: "72px",
          zIndex:100
        }}
        value={currentTab}
        onChange={(e, val: any) => setCurrentTab(val)}
        aria-label="basic tabs example"
        // indicatorColor="secondary"
      >
        <Tab
          icon={<SchoolIcon />}
          label="Graduation Status"
          value="graduation"
          iconPosition="start"
          sx={{ color: "#a2a2a2", fontWeight: "bold" }}
        />
        <Tab
          icon={<BarChart />}
          label="My Mastery"
          value="mastery"
          iconPosition="start"
          sx={{ color: "#a2a2a2", fontWeight: "bold" }}
        />
      </Tabs>
      {currentTab === "graduation" ? (
        <GraduateReportStatusPage />
      ) : (
        <MasteryLevelPage />
      )}
    </Box>
  );
};
